import * as React from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';

let styles = require('./DataRow.scss');
let classNames = require('classnames/bind').bind(styles);

export interface DataRowProps {
    iconName: string;
    children: JSX.Element | JSX.Element[];
    className?: string;
    iconClassName?: string;
    iconContainerClassName?: string;
    childrenClassName?: string;
    childrenAriaLabel?: string;
}

const DataRow = observer(function DataRow(props: DataRowProps) {
    let {
        children,
        iconName,
        className,
        iconClassName,
        iconContainerClassName,
        childrenClassName,
        childrenAriaLabel,
    } = props;
    return (
        <div className={classNames(styles.dataRow, className)}>
            <div className={styles.dataRowIcon}>
                <div className={classNames(styles.iconContainer, iconContainerClassName)}>
                    <Icon iconName={iconName} className={iconClassName} />
                </div>
            </div>

            <div
                className={classNames(styles.dataRowValue, childrenClassName, 'allowTextSelection')}
                aria-label={childrenAriaLabel}>
                {children}
            </div>
        </div>
    );
});
export default DataRow;
